import { CartAddEvent } from '@theme/events';

/*
 * Build Your Own Bundle — client-side builder.
 *
 * Mounts into #dgt-bb-root (placed in the page body) and renders the whole builder from
 * live product data (the `bundle-builder` collection). Self-contained so it can be loaded
 * globally from layout/theme.liquid gated to the page — harmless anywhere #dgt-bb-root is
 * absent. "Add bundle" adds every picked variant as a ONE-TIME purchase (no selling plan)
 * in one request and opens the drawer; the real 15% is applied by Shopify's automatic
 * bundle discount (this only shows the estimate).
 */
(function () {
  'use strict';
  // Mount point: prefer #dgt-bb-root from the page body; otherwise (the default page
  // template renders other content, e.g. Mission) take over the main content area. This
  // script is only loaded on the builder page (gated in layout/theme.liquid), so the
  // takeover is safe.
  var root = document.getElementById('dgt-bb-root');
  if (!root) {
    var main = document.getElementById('MainContent') || document.querySelector('main');
    if (!main) return;
    main.innerHTML = '';
    root = document.createElement('div');
    root.id = 'dgt-bb-root';
    main.appendChild(root);
  }

  var T1 = 3, T1P = 15; // single tier: add 3 teas, save 15% (4-tier retired for now)
  var ADD_URL = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/add.js';

  root.innerHTML = '<div class="dgt-bb"><p class="dgt-bb__empty" style="padding:60px 0">Loading your bundle…</p></div>';

  function money(c) { return '$' + (c / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function withWidth(url, w) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

  // Prefer the server-rendered data (carries the homepage pack_images photo per flavor);
  // fall back to fetching the AJAX product JSON if the blob is missing.
  var dataEl = document.getElementById('dgt-bb-data');
  var seeded = null;
  if (dataEl) { try { seeded = JSON.parse(dataEl.textContent); } catch (e) { seeded = null; } }

  if (seeded && seeded.length) {
    build(seeded);
  } else {
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'collections/bundle-builder/products.json?limit=40')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var handles = (d.products || []).map(function (p) { return p.handle; });
        return Promise.all(handles.map(function (h) {
          return fetch('/products/' + h + '.js').then(function (r) { return r.json(); }).catch(function () { return null; });
        }));
      })
      .then(function (products) {
        var groups = products.filter(Boolean).map(function (p) {
          return { title: p.title, variants: p.variants.map(function (v) {
            var flavor = v.title === 'Default Title' ? p.title : v.title;
            var img = (v.featured_image && v.featured_image.src) || p.featured_image || (p.images && p.images[0]) || '';
            return { id: v.id, flavor: flavor, price: v.price, available: v.available, img: img };
          }) };
        });
        build(groups);
      })
      .catch(function () {
        root.innerHTML = '<div class="dgt-bb"><p class="dgt-bb__empty" style="padding:60px 0">Sorry — the bundle builder couldn\'t load. Please refresh.</p></div>';
      });
  }

  function build(groups) {
    if (!groups || !groups.length) {
      root.innerHTML = '<div class="dgt-bb"><p class="dgt-bb__empty" style="padding:60px 0">No bundle products are available right now.</p></div>';
      return;
    }

    var items = {}; // vid -> { qty, price, flavor, group, img, available }
    groups.forEach(function (g) {
      g.variants.forEach(function (v) {
        items[v.id] = { qty: 0, price: v.price, flavor: v.flavor, group: g.title, img: v.img, available: v.available };
      });
    });

    root.innerHTML =
      '<div class="dgt-bb">' +
        '<header class="dgt-bb__hero">' +
          '<p class="dgt-bb__eyebrow">Build your own</p>' +
          '<h1 class="dgt-bb__title">Mix a bundle,<br><span class="hl">save more</span> as you go.</h1>' +
          '<p class="dgt-bb__lede">Pick any of our best-selling teas, matchas &amp; hot chocolates. The more you add, the deeper the discount &mdash; applied automatically at checkout.</p>' +
          '<div class="dgt-bb__tiers">' +
            '<div class="dgt-bb__tier dgt-bb__tier--1"><span class="dgt-bb__chip">' + T1 + '</span><span class="dgt-bb__tierlbl">teas in your bundle</span><span class="dgt-bb__tierpct">&minus;' + T1P + '%</span></div>' +
          '</div>' +
        '</header>' +
        '<div class="dgt-bb__layout">' +
          '<main class="dgt-bb__catalog">' + groups.map(groupHTML).join('') + '</main>' +
          '<aside class="dgt-bb__rail"><div class="dgt-bb__summary">' +
            '<div class="dgt-bb__shead"><h3>Your bundle</h3><p data-bb-sub>Add ' + T1 + ' to unlock your discount</p></div>' +
            '<div class="dgt-bb__progwrap"><div class="dgt-bb__progline">' +
              '<div class="dgt-bb__progfill" data-bb-fill></div>' +
              '<div class="dgt-bb__tick dgt-bb__tick--max" data-bb-tick1 style="left:100%"><div class="dgt-bb__dot">' + T1 + '</div><div class="dgt-bb__cap">' + T1P + '% off</div></div>' +
            '</div></div>' +
            '<div class="dgt-bb__nudge" data-bb-nudge><span class="dgt-bb__ico">✦</span><span data-bb-nudgetext>Add ' + T1 + ' teas to save ' + T1P + '%.</span></div>' +
            '<div class="dgt-bb__lines" data-bb-lines></div>' +
            '<div class="dgt-bb__totals" data-bb-totals></div>' +
            '<button type="button" class="dgt-bb__checkout" data-bb-checkout disabled>Add bundle to cart</button>' +
          '</div></aside>' +
        '</div>' +
      '</div>';

    function groupHTML(g) {
      return '<section class="dgt-bb__group">' +
        '<div class="dgt-bb__grouphead"><h2>' + esc(g.title) + '</h2><span class="dgt-bb__rule"></span><span class="dgt-bb__groupcount">' + g.variants.length + ' flavor' + (g.variants.length === 1 ? '' : 's') + '</span></div>' +
        '<div class="dgt-bb__cards">' + g.variants.map(cardHTML).join('') + '</div></section>';
    }
    function cardHTML(v) {
      return '<div class="dgt-bb__card' + (v.available ? '' : ' is-out') + '" data-bb-card data-vid="' + v.id + '">' +
        '<div class="dgt-bb__thumb">' + (v.img ? '<img src="' + esc(withWidth(v.img, 320)) + '" alt="' + esc(v.flavor) + '" loading="lazy">' : '') + '<span class="dgt-bb__qty" data-bb-qty hidden></span></div>' +
        '<p class="dgt-bb__flavor">' + esc(v.flavor) + '</p>' +
        '<p class="dgt-bb__price">' + (v.available ? money(v.price) : 'Sold out') + '</p>' +
        '<div class="dgt-bb__foot">' +
          (v.available
            ? '<button type="button" class="dgt-bb__add" data-bb-add>Add</button>' +
              '<div class="dgt-bb__stepper" data-bb-stepper hidden><button type="button" data-bb-dec aria-label="Remove one">–</button><span class="dgt-bb__q" data-bb-q>0</span><button type="button" data-bb-inc aria-label="Add one">+</button></div>'
            : '<button type="button" class="dgt-bb__add" disabled>Sold out</button>') +
        '</div></div>';
    }

    var bb = root.querySelector('.dgt-bb');
    var subEl = bb.querySelector('[data-bb-sub]');
    var fillEl = bb.querySelector('[data-bb-fill]');
    var tick1 = bb.querySelector('[data-bb-tick1]');
    var nudgeEl = bb.querySelector('[data-bb-nudge]');
    var nudgeText = bb.querySelector('[data-bb-nudgetext]');
    var nudgeIco = nudgeEl.querySelector('.dgt-bb__ico');
    var linesEl = bb.querySelector('[data-bb-lines]');
    var totalsEl = bb.querySelector('[data-bb-totals]');
    var checkoutBtn = bb.querySelector('[data-bb-checkout]');

    function totalQty() { var n = 0; for (var k in items) n += items[k].qty; return n; }
    function rate(n) { return n >= T1 ? T1P / 100 : 0; }

    function paintCard(vid) {
      var card = bb.querySelector('[data-bb-card][data-vid="' + vid + '"]');
      if (!card) return;
      var it = items[vid];
      var stepper = card.querySelector('[data-bb-stepper]');
      var addBtn = card.querySelector('[data-bb-add]');
      var qEl = card.querySelector('[data-bb-q]');
      var badge = card.querySelector('[data-bb-qty]');
      if (it.qty > 0) {
        card.classList.add('is-selected');
        if (addBtn) addBtn.hidden = true;
        if (stepper) stepper.hidden = false;
        if (qEl) qEl.textContent = it.qty;
        if (badge) { badge.hidden = false; badge.textContent = it.qty; }
      } else {
        card.classList.remove('is-selected');
        if (addBtn) addBtn.hidden = false;
        if (stepper) stepper.hidden = true;
        if (badge) { badge.hidden = true; badge.textContent = ''; }
      }
    }

    function render() {
      var n = totalQty(), r = rate(n);
      var chosen = [], subtotal = 0;
      for (var k in items) { if (items[k].qty > 0) { chosen.push(k); subtotal += items[k].price * items[k].qty; } }
      var save = Math.round(subtotal * r);

      fillEl.style.width = Math.min(n / T1, 1) * 100 + '%';
      fillEl.classList.toggle('is-max', n >= T1);
      tick1.classList.toggle('is-hit', n >= T1);

      nudgeEl.classList.remove('is-max');
      if (n >= T1) { nudgeEl.classList.add('is-max'); nudgeText.textContent = T1P + '% off unlocked!'; nudgeIco.textContent = '★'; subEl.textContent = "You're saving " + T1P + '% on your bundle.'; }
      else { var left = T1 - n; nudgeText.textContent = 'Add ' + left + ' more tea' + (left > 1 ? 's' : '') + ' to save ' + T1P + '%.'; nudgeIco.textContent = '✦'; subEl.textContent = n + ' of ' + T1 + ' to your discount'; }

      if (chosen.length === 0) { linesEl.innerHTML = '<div class="dgt-bb__empty">Your bundle is empty. Add a few teas to begin.</div>'; }
      else {
        linesEl.innerHTML = chosen.map(function (k) {
          var it = items[k];
          return '<div class="dgt-bb__lineitem">' +
            '<div class="dgt-bb__li-thumb">' + (it.img ? '<img src="' + esc(withWidth(it.img, 80)) + '" alt="">' : '') + '</div>' +
            '<div><div class="dgt-bb__li-name">' + esc(it.flavor) + '</div><div class="dgt-bb__li-sub">' + esc(it.group) + ' · ' + money(it.price) + (it.qty > 1 ? ' × ' + it.qty : '') + '</div></div>' +
            '<div class="dgt-bb__li-price">' + money(it.price * it.qty) + '</div>' +
            '<button class="dgt-bb__li-x" type="button" data-bb-remove="' + k + '" aria-label="Remove ' + esc(it.flavor) + '">✕</button></div>';
        }).join('');
      }

      if (chosen.length === 0) { totalsEl.innerHTML = '<div class="dgt-bb__totrow"><span>Subtotal</span><span>' + money(0) + '</span></div>'; }
      else {
        totalsEl.innerHTML =
          '<div class="dgt-bb__totrow"><span>Subtotal · ' + n + ' item' + (n > 1 ? 's' : '') + '</span><span>' + money(subtotal) + '</span></div>' +
          (r > 0 ? '<div class="dgt-bb__totrow is-save"><span>Bundle discount (' + Math.round(r * 100) + '%)</span><span>−' + money(save) + '</span></div>' : '') +
          '<div class="dgt-bb__totrow is-grand"><span>Total</span><span>' + (r > 0 ? '<span class="was">' + money(subtotal) + '</span>' : '') + money(subtotal - save) + '</span></div>';
      }

      checkoutBtn.disabled = chosen.length === 0;
      checkoutBtn.textContent = r > 0 ? ('Add bundle · save ' + money(save)) : 'Add bundle to cart';
    }

    function change(vid, delta) { var it = items[vid]; if (!it) return; it.qty = Math.max(0, it.qty + delta); paintCard(vid); render(); }

    bb.addEventListener('click', function (e) {
      var card = e.target.closest('[data-bb-card]');
      if (card) {
        if (e.target.closest('[data-bb-add]') || e.target.closest('[data-bb-inc]')) { change(card.dataset.vid, 1); return; }
        if (e.target.closest('[data-bb-dec]')) { change(card.dataset.vid, -1); return; }
      }
      var rm = e.target.closest('[data-bb-remove]');
      if (rm) { var vid = rm.getAttribute('data-bb-remove'); if (items[vid]) { items[vid].qty = 0; paintCard(vid); render(); } }
    });

    function cartSectionIds() {
      var ids = {};
      document.querySelectorAll('cart-items-component').forEach(function (c) { if (c.dataset && c.dataset.sectionId) ids[c.dataset.sectionId] = 1; });
      return Object.keys(ids).join(',');
    }

    checkoutBtn.addEventListener('click', function () {
      if (checkoutBtn.disabled) return;
      var payload = [];
      // _pack_size: 1 so each flavor shows as "1-Pack x N" in the cart (matches the PDP).
      for (var k in items) { if (items[k].qty > 0) payload.push({ id: parseInt(k, 10), quantity: items[k].qty, properties: { _pack_size: '1' } }); }
      if (!payload.length) return;
      checkoutBtn.classList.add('is-busy');
      checkoutBtn.disabled = true;
      fetch(ADD_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: payload, sections: cartSectionIds(), sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json().then(function (dd) { return { ok: r.ok, d: dd }; }); })
        .then(function (res) {
          checkoutBtn.classList.remove('is-busy');
          checkoutBtn.disabled = false;
          if (!res.ok) return;
          var comp = document.querySelector('cart-items-component');
          var sid = (comp && comp.dataset.sectionId) || '';
          document.body.dispatchEvent(new CartAddEvent({}, sid, { source: 'dgt-bundle-builder', sections: res.d.sections }));
          // Open the drawer once the morph has populated it. The component's showDialog()
          // can no-op when triggered from a non-cart page, so fall back to opening the
          // native <dialog> directly.
          setTimeout(function () {
            var drawer = document.querySelector('cart-drawer-component');
            if (!drawer) return;
            try { if (typeof drawer.showDialog === 'function') drawer.showDialog(); } catch (e) {}
            var dlg = drawer.querySelector('dialog');
            if (dlg && !dlg.open) { try { dlg.showModal(); } catch (e) {} }
          }, 250);
        })
        .catch(function () { checkoutBtn.classList.remove('is-busy'); checkoutBtn.disabled = false; });
    });

    render();
  }
})();
